import React from "react";
import { object, array, number, string } from "prop-types";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card8.m.css";

const StoryCard8 = ({ story, aspectRatio, imageType, headerType, headerLevel }) => {
  return (
    <div className="story-card story-card-8" styleName="story-card-8" id="story-card-8">
      <Link href={`/${story.slug}`}>
        <div styleName="card-wrapper">
          <CardImage
            showVideoIcon
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[200, 400]}
            sizes="(max-width: 1024px) 10vw, 50vw"
          />
          <div styleName="content">
            <Headline
              text={story.headline}
              headerType={headerType}
              headerLevel={headerLevel}
              story={story}
              lineClampClass="line-clamp line-clamp-2"
            />
            <StoryDate story={story} />
          </div>
        </div>
      </Link>
    </div>
  );
};

StoryCard8.defaultProps = {
  aspectRatio: [1, 1],
  imageType: "image1x1",
  headerType: 5,
  headerLevel: 2
};

StoryCard8.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default StoryCard8;
